import React from 'react';
import { Skeleton, Grid } from '@mui/material';
const skeletonSize = [1, 2, 3, 4];

function TagListSkeleton() {
  return (
    <Grid container spacing={2}>
      {skeletonSize.map(key => (
        <Grid item key={key}>
          <Skeleton
            variant="rounded"
            width={100}
            height={60}
            x={theme => ({
              borderRadius: theme.shape.borderRadius * 2,
            })}
          />
        </Grid>
      ))}
    </Grid>
  );
}

export default TagListSkeleton;
